import { Editor, Element } from 'slate';
import { BLOCK_JUMP } from '../../types';

export const withJumps = (editor: Editor) => {
  const { isVoid } = editor;

  editor.isVoid = (element: Element) => {
    return element.type === BLOCK_JUMP ? true : isVoid(element);
  };

  return editor;
};
